export const ACTIONS_OVERVIEW = {
	OVERVIEW: 'overview',
	OVERVIEW_PARTY_ADMIN: 'overview_party_admin',
	OVERVIEW_PARTY_CANDIDATE: 'overview_party_candidate',
} as const;
